<template>
  <div>
    <a-modal
      v-model="isShowData"
      @ok="handleOk"
      :maskClosable="false"
      :centered="true"
    >
      <div>
        <a-row class="pb-2 center">
          <a-col :span="24">
            <img
              alt="time_out_img"
              width="77px"
              height="77px"
              src="../assets/time_out_img.png"
            />
          </a-col>
        </a-row>
        <a-row class="mt-10 center">
          <a-col :span="24">
            <span class="header-txt-pop">We didn’t feel the love</span>
          </a-col>
        </a-row>
        <a-row class="mt-20 center">
          <a-col :span="24">
            <p class="confirm-contain-txt">
              You were inactive for too long, so we logged you out. Come back
              when you’re ready.
            </p>
          </a-col>
        </a-row>
        <a-row class="pb-2 center">
          <a-col :span="24">
            <a-button @click="handleOk" class="confirm-grey-btn" type="primary"
              >Log in</a-button
            >
          </a-col>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>
<script>
export default {
  name: "TimeOutPopUp",
  data() {
    const isShowData = this.isShow;
    return {
      isShowData,
      visible: false,
    };
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    logo: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    headerText: {
      type: String,
      default: "",
    },
    containText: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "",
    },
    className: {
      type: String,
      default: null,
    },
  },
  watch: {
    isShow(newVal) {
      this.isShowData = newVal;
    },
  },
  methods: {
    showModal() {
      this.visible = this.isShowData;
    },
    handleOk() {
      this.isShowData = false;
      this.$emit("closePopup", false);
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .ant-modal-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    height: 100%;
    background-color: #61616c !important;
  }
  .ant-modal-footer {
    display: none !important;
  }
  .ant-modal-close-x {
    display: none !important;
  }
  .ant-modal {
    width: 700px !important;
  }
  .ant-modal-content {
    padding: 4% 18%;
    border-radius: 10px !important;
  }

  button.confirm-grey-btn.ant-btn.ant-btn-primary {
    width: 150px !important;
    min-height: 45px !important;
    margin-top: 10px;
    font-size: 18px !important;
    background-color: #edeef5 !important;
  }
  button.confirm-grey-btn.ant-btn.ant-btn-primary:hover {
    background-color: #bfc3d6 !important;
  }

  @media screen and (max-width: 590px) {
    .ant-modal {
      width: 80%;
    }
  }
}

.min-error-popup .confirm-contain-txt {
  padding: 10px 48px !important;
}
</style>
